import { AntVDagreLayout } from './algorithm/antv-dagre/index.js';
import { CircularLayout } from './algorithm/circular/index.js';
import { ConcentricLayout } from './algorithm/concentric/index.js';
import { D3ForceLayout } from './algorithm/d3-force/index.js';
import { D3Force3DLayout } from './algorithm/d3-force-3d/index.js';
import { DagreLayout } from './algorithm/dagre/index.js';
import { ForceLayout } from './algorithm/force/index.js';
import { ForceAtlas2Layout } from './algorithm/force-atlas2/index.js';
import { FruchtermanLayout } from './algorithm/fruchterman/index.js';
import { GridLayout } from './algorithm/grid/index.js';
import { MDSLayout } from './algorithm/mds/index.js';
import { RadialLayout } from './algorithm/radial/index.js';
import { RandomLayout } from './algorithm/random/index.js';

const registry = {
    'antv-dagre': AntVDagreLayout,
    'd3-force-3d': D3Force3DLayout,
    'd3-force': D3ForceLayout,
    'force-atlas2': ForceAtlas2Layout,
    circular: CircularLayout,
    concentric: ConcentricLayout,
    dagre: DagreLayout,
    force: ForceLayout,
    fruchterman: FruchtermanLayout,
    grid: GridLayout,
    mds: MDSLayout,
    radial: RadialLayout,
    random: RandomLayout,
};

export { registry };
